define(["require", "exports", "tslib", "mobx-react", "react", "./index"], function (require, exports, tslib_1, mobx_react_1, React, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Header = void 0;
    React = tslib_1.__importStar(React);
    exports.Header = (0, mobx_react_1.observer)((props) => {
        return React.createElement(index_1.HGroup, { id: props.id, className: "sub-header " + (props.className || ""), style: props.style },
            React.createElement("div", { className: "sub-header-title" }, props.title),
            props.children);
    });
});
